import "./why-us.scss";

import HandLoveSign from "./hand-love-sign.svg";
import UIButton from "../../ui-kit/button";
import { translateString } from "../../../helpers/translator";

export default function WhyChooseUs({ language }) {
  return (
    <section className="why-us" id="about">
      <div className="container relz1">
        <h3 className="section-title">
          {translateString("HOME.WHYUS.whyUs", language)}
        </h3>

        <h2 className="why-us__title">
          {translateString("HOME.WHYUS.header_1", language)}
        </h2>

        <p className="description">
          {translateString("HOME.WHYUS.header_2", language)}
        </p>

        <div className="features-grid">
          <div className="feature">
            <span className="feature-number">01</span>
            <h3>{translateString("HOME.WHYUS.feature.header.1", language)}</h3>
            <p>{translateString("HOME.WHYUS.feature.content.1", language)}</p>
          </div>

          <div className="featur desktop-onlye"></div>
          <div className="feature">
            <span className="feature-number">02</span>
            <h3>{translateString("HOME.WHYUS.feature.header.2", language)}</h3>
            <p>{translateString("HOME.WHYUS.feature.content.2", language)}</p>
          </div>

          <div className="feature desktop-only"></div>
          <div className="feature desktop-only"></div>
          <div className="feature">
            <span className="feature-number">03</span>
            <h3>{translateString("HOME.WHYUS.feature.header.3", language)}</h3>
            <p>{translateString("HOME.WHYUS.feature.content.3", language)}</p>
          </div>

          <div className="feature desktop-only"></div>
          <div className="feature">
            <span className="feature-number">04</span>
            <h3>{translateString("HOME.WHYUS.feature.header.4", language)}</h3>
            <p>{translateString("HOME.WHYUS.feature.content.4", language)}</p>
          </div>
        </div>

        <div className="why-us__purple-box">
          <div className="why-us__purple-box-content relz1">
            <img src={HandLoveSign} alt="Hand Love Sign" />
            <h3 className="section-title">[{translateString("HOME.WHYUS.box_header", language)}]</h3>
            <h2>{translateString("HOME.WHYUS.box_content", language)}</h2>
            <a href="#quote">
              <UIButton text={translateString("HOME.HEADER.getQuote", language)} size="large" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
